import React, { Fragment, useEffect, useState } from 'react';
import AuthServices from '../../../Api/Auth/AuthServices';
import ServicesServices from '../../../Api/AdBazar/Services/ServicesServices';
import { Box, Button, Collapse, FormControl, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography, Autocomplete } from '@mui/material';
import Colors from '../../../Assets/Styles/Colors';
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';
import { FilterAltTwoTone, KeyboardArrowLeft, KeyboardArrowRight, RemoveRedEye } from '@mui/icons-material';
import moment from 'moment';
import SelectField from '../../../Components/Fields/SelectField';
import { useTheme } from '@emotion/react';
import { useNavigate } from 'react-router-dom';
import { CircleLoading } from '../../../Components/Loaders/CircleLoading';

const tableHead = ["Name", "Phone No", "Date", "Industry", "Service", "City", "Actions"];

function DataFilter(props) {
  const {
    servicesData,
    numbersData,
    selectedService,
    selectedNumber,
    setSelectedService,
    setSelectedNumber,
    setName,
    sortData,
    name
  } = props;
  const [filterCollapse, setFilterCollapse] = useState(true);

  const filterData = () => {
    sortData("", "", name, "", selectedService.id, selectedNumber);
  };

  const clearData = () => {
    setName("");
    setSelectedService("");
    setSelectedNumber("");
    sortData();
  };

  return (
    <Box sx={{ bgcolor: Colors.white, p: 2, borderRadius: "12px", mt: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="body1" fontWeight="bold" color="initial">
          Filters
        </Typography>
        <IconButton
          onClick={() => setFilterCollapse(!filterCollapse)}
          color="primary"
        >
          <FilterAltTwoTone sx={{ color: Colors.primary }} />
        </IconButton>
      </Box>

      <Collapse in={filterCollapse}>
        <Grid container spacing={2}>
          <Grid item md={4}>
            <FormControl fullWidth>
              <TextField
                value={name}
                onChange={(e) => setName(e.target.value)}
                label={"Name"}
              />
            </FormControl>
          </Grid>

          <Grid item md={4}>
            <FormControl fullWidth>
              <SelectField
                setState={(item, name) => {
                  setSelectedService({ id: item, name: name });
                }}
                stateValue={selectedService.name}
                data={servicesData}
                label={"Services"}
              />
            </FormControl>
          </Grid>

          <Grid item md={4}>
            <FormControl fullWidth>
              <Autocomplete
                options={numbersData}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setSelectedNumber(newValue);
                  }
                }}
                renderInput={(params) => <TextField {...params} label="Phone Number" />}
              // onKeyDown={(e) => handleSearch(e)}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} display="flex" justifyContent="flex-end">
            <Button
              onClick={clearData}
              variant="outlined"
              sx={{
                mx: 1,
                textTransform: "capitalize",
                minWidth: "100px",
                boxShadow:
                  `0px 3px 1px -2px rgb(0 0 0 / 20%), 
                  0px 2px 2px 0px rgb(0 0 0 / 14%),
                  0px 1px 5px 0px rgb(0 0 0 / 12%)`,
              }}
            >
              Clear
            </Button>
            <Button
              onClick={filterData}
              variant="contained"
              sx={{
                textTransform: "capitalize",
                minWidth: "100px",
                boxShadow:
                  `0px 3px 1px -2px rgb(0 0 0 / 20%),
                  0px 2px 2px 0px rgb(0 0 0 / 14%),
                  0px 1px 5px 0px rgb(0 0 0 / 12%)`,
              }}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </Collapse>
    </Box>
  );
}

function TablePaginationActions(props) {
  const theme = useTheme;

  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

function ServiceProvider() {
  const [loading, setLoading] = useState(false);
  const [agency, setAgency] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState("");
  const [services, setServices] = useState([]);
  const [numbers, setNumbers] = useState([]);
  const [name, setName] = useState("")
  const [selectedService, setSelectedService] = useState({ id: "", name: "" });
  const [selectedNumber, setSelectedNumber] = useState("");
  const agencyRole = "Service Provider";

  const navigate = useNavigate();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllUsers(newPage + 1, rowsPerPage, name, "", selectedService?.id, selectedNumber, agencyRole);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Math.floor(event.target.value));
    setPage(0);
    getAllUsers(page, event.target.value, name, "", selectedService?.id, selectedNumber, agencyRole);
  };

  const getAllServices = async () => {
    try {
      const result = await ServicesServices.getAllServices();
      setServices(result?.data?.service)
    } catch (error) {
      console.log(error)
    }
  }

  const getAllUsers = async (page, rows, name, industry, service, phone, role) => {
    setLoading(true)
    try {
      const result = await AuthServices.getAllUsers(
        page ? page : 1,
        rows ? rows : 10,
        name ? name : "",
        industry ? industry : "",
        service ? service : "",
        phone ? phone : "",
        agencyRole,
      );
      console.log("🚀 ~ getAllUsers ~ result:", result)
      const arrayOfPhNum = result?.data?.users?.map((item) => item.phone_Number);
      setNumbers(arrayOfPhNum);
      setAgency(result?.data?.users)
      setCount(result?.data?.pagination?.totalUsers)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  }

  const sort = (page, rowsPerPage, name, industry, service, phone) => {
    console.log("🚀 ~ sort ~ service:", service)
    getAllUsers(page, rowsPerPage, name, industry, service, phone)
  };

  useEffect(() => {
    getAllUsers();
    getAllServices();
  }, [])
  return (
    <Fragment>
      <Box
        sx={{
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Service Providers
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Service Providers"]} />
          </Grid>
        </Grid>
        <DataFilter
          sortData={(page, rowsPerPage, name, industry, service, phone) =>
            sort(page, rowsPerPage, name, industry, service, phone)
          }
          servicesData={services}
          numbersData={numbers}
          selectedService={selectedService}
          selectedNumber={selectedNumber}
          name={name}
          setSelectedService={setSelectedService}
          setSelectedNumber={setSelectedNumber}
          setName={setName}
        />
        {loading ? (
          <CircleLoading />
        ) : (
          <Box>
            <TableContainer
              component={Paper}
              sx={{
                "&::-webkit-scrollbar": {
                  bgcolor: Colors.white,
                  height: "8px",
                  borderRadius: "10px",
                  cursor: "pointer",
                },
                "&::-webkit-scrollbar-thumb": {
                  bgcolor: Colors.primary,
                  borderRadius: "10px",
                  cursor: "pointer",
                },
                "&.MuiPaper-root": {
                  borderRadius: "12px",
                  mt: 2,
                  boxShadow: 0,
                },
              }}
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow sx={{ bgcolor: Colors.lightGray }}>
                    {tableHead.map((item, index) => (
                      <TableCell
                        key={index}
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                          }}
                        >
                          {item}
                        </Typography>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {agency.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Typography>
                          {row?.name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>
                          {row?.phone_Number}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>
                          {moment(row?.created_at).format("DD/MM/YYYY")}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>
                          {row?.additional?.industry?.name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>
                          {row?.additional?.services?.name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>
                          {row?.city}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Tooltip title="View">
                          <IconButton
                            onClick={() => {
                              navigate(`/service-provider-details/${row?._id}`, { state: row });
                            }}
                          >
                            <RemoveRedEye />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Table sx={{ marginTop: "12px" }}>
              <TablePagination
                sx={{
                  borderBottom: "none",
                  bgcolor: Colors.white,
                  borderRadius: "12px",
                }}
                rowsPerPageOptions={[10, 20, 30]}
                colSpan={12}
                count={+count}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: {
                    "aria-label": "rows per page",
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Table>
          </Box>
        )}
      </Box>
    </Fragment >
  )
}

export default ServiceProvider;